var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { computed, observable, makeObservable } from 'mobx';
export class AppClockInternals {
    parent;
    constructor(parent) {
        makeObservable(this);
        this.parent = parent;
    }
    get appClock() {
        return this.parent;
    }
    get isAppClockPaused() {
        return !!this.pauseStartAppTime;
    }
    set isAppClockPaused(newPaused) {
        if (newPaused === this.isAppClockPaused)
            return; // no change
        if (newPaused && !this.isAppClockPaused) {
            this.pauseStartAppTime = this.appClock.currentTime;
            return;
        }
        if (!newPaused && this.isAppClockPaused) {
            // stop pause
            this.delayDueToOldPausesInMilliseconds += this.millisecondsDelayDueToCurrentPause;
            this.pauseStartAppTime = 0;
            return;
        }
    }
    pauseStartAppTime = 0;
    delayDueToOldPausesInMilliseconds = 0;
    get millisecondsDelayToRuntimeClock() {
        return this.delayDueToOldPausesInMilliseconds + this.millisecondsDelayDueToCurrentPause;
    }
    get millisecondsDelayDueToCurrentPause() {
        if (this.isAppClockPaused) {
            return new Date().getTime() - this.pauseStartAppTime;
        }
        return 0;
    }
}
__decorate([
    computed
], AppClockInternals.prototype, "isAppClockPaused", null);
__decorate([
    observable
], AppClockInternals.prototype, "pauseStartAppTime", void 0);
__decorate([
    observable
], AppClockInternals.prototype, "delayDueToOldPausesInMilliseconds", void 0);
